import(/* webpackMode: "eager" */ "/app/apps/user/app/(auth)/forgot-password/page.tsx");
